import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nama Jenis Pengeluaran", -1)
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "Keterangan", -1)
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, "Aktif", -1)
const _hoisted_8 = { class: "container-btn-action" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Simpan")

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import { Form, Field, FieldArray, ErrorMessage } from 'vee-validate'
import vSelect from 'vue-select'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import Checkbox from 'primevue/checkbox'
import { onMounted, getCurrentInstance, ref, reactive } from 'vue'
import { IBankForm } from '@/utils/interfaces/iBank'
import apiUseCase from '@/usecase/apiUseCase'
import { isNull } from 'lodash'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const store = useStore()
console.log('store', store.state.hjpTable.modal.data)
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
const dataForm = ref()
const titleButton = ref('Simpan Jenis Pengeluaran')
const isUpdate = ref(false)

const moduleStore = 'hjpTable'
const endpoint = '/management/v1/MsExpensesType'

const initialValues = {
  Name: store.state[moduleStore].modal.data ? store.state[moduleStore].modal.data.Name : '',
  IsActive: store.state[moduleStore].modal.data ? store.state[moduleStore].modal.data.IsActive : true,
  Description: store.state[moduleStore].modal.data ? store.state[moduleStore].modal.data.Description : ''
}

const schema = Yup.object().shape({
  Name: Yup.string()
    .required('Nama Jenis Pengeluaran harus tidak boleh kosong')
    .max(30, 'Nama Jenis Pengeluaran maksimal 30 karakter!')
    .matches(rgxExp.notSpaceInFirstChar, 'Nama Jenis Pengeluaran tidak valid!')
    .test('unique-name', 'Nama Jenis Pengeluaran sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['name']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Name === val)
        if (store.state[moduleStore].modal.data) {
          return filterResult.length === 0 || val === initialValues.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
})

const attrModalConfirmation = reactive({
  show: false,
  title: '',
  subTitle: '',
  btnSubmitTitle: '',
  imgContent: require('@/assets/img/modal-confirmation/expenses-type-add-update.svg')
})

const checkAddOrUpdate = () => {
  if (store.state[moduleStore].modal.data) {
    attrModalConfirmation.title = 'Simpan Perubahan Jenis Pengeluaran?'
    attrModalConfirmation.subTitle = 'Pastikan data jenis pengeluaran sudah benar dan sesuai dengan yang Anda inginkan.'
    attrModalConfirmation.btnSubmitTitle = titleButton.value
    isUpdate.value = true
    // if (store.state[moduleStore].modal.data.Id) {
    //   console.log('aasdasd')
    // }
  } else {
    attrModalConfirmation.title = 'Simpan Jenis Pengeluaran '
    attrModalConfirmation.subTitle = 'Pastikan data jenis pengeluaran sudah benar dan sesuai dengan yang Anda inginkan.'
    attrModalConfirmation.btnSubmitTitle = titleButton.value
  }
}

const onSubmit = (val: any) => {
  console.log('masukk submit', val)
  dataForm.value = {
    Name: val.Name,
    IsActive: val.IsActive,
    IsDelete: false,
    Description: val.Description
  }
  attrModalConfirmation.show = true
}

const hideSidebar = () => {
  // console.log('hide')
  store.dispatch('setShowModalFormDl', false)
  store.dispatch('storeRowDataTable', null)
  // console.log('store', store)
}

const changeOk = (val: any) => {
  console.log('valll', val)
}

const onSearchOption = (search: any, loading: any) => {
  console.log('search', search)
}

const onSelectedBank = (selected: any) => {
  console.log('selected', selected)
}

const onSubmitConfirmation = async () => {
  console.log('aaaaaa')
  const toastMessage = isUpdate.value ? 'Berhasil mengubah Jenis Pengeluaran' : 'Berhasil menambahkan Jenis Pengeluaran'
  const toastDetailMesssage = isUpdate.value ? 'Jenis Pengeluaran sudah diubah dan dapat digunakan pada fitur lain.' : 'Jenis Pengeluaran sudah ditambahkan dan dapat digunakan pada fitur lain.'
  const response = !isUpdate.value ? await apiUseCase.postOrPut(endpoint, null, dataForm.value) : await apiUseCase.postOrPut(endpoint, store.state[moduleStore].modal.data.Id, dataForm.value)
  console.log('response', response)
  if (!response.error) {
    store.dispatch('setShowModal', false)
    store.dispatch('setReloadDataTable', true)
    $toast.add({
      severity: 'success',
      summary: toastMessage,
      detail: toastDetailMesssage,
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else {
    // store.dispatch('setShowModal', false)
    $toast.add({
      severity: 'error',
      detail: response.message,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  // eslint-disable-next-line no-use-before-define
  hideDialogConfirmation()
  hideSidebar()
}

const hideDialogConfirmation = () => {
  attrModalConfirmation.show = false
}

onMounted(() => {
  console.log('store', store.state.hjpTable.modal)
  let titleForm = 'Tambah'
  if (store.state.hjpTable.modal.data) {
    titleForm = 'Edit'
    titleButton.value = 'Simpan perubahan'
  }
  checkAddOrUpdate()
  console.log(initialValues)
  store.dispatch('setTitleFormSidebar', `${titleForm} Jenis Pengeluaran`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values }) => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_unref(Field), { name: "Name" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.Name,
                "onUpdate:modelValue": ($event: any) => ((values.Name) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                placeholder: "Tulis Jenis Pengeluaran"
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_3, _toDisplayString(errors.Name), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(Field), {
            name: "Description",
            as: "textarea",
            placeholder: "Tulis Keterangan",
            class: "input-primary"
          }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(Textarea), {
                id: "Description",
                autocomplete: "nope",
                autoResize: true,
                ref: "addressRef",
                rows: "3",
                onChange: handleChange,
                onBlur: handleBlur
              }, null, 8, ["onChange", "onBlur"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(Field), { name: "IsActive" }, {
            default: _withCtx(({ field }) => [
              _createVNode(_unref(InputSwitch), _mergeProps({ class: "input-success" }, field, {
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                inputId: "isactive"
              }), null, 16, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(HjpCofirmModal, {
      show: attrModalConfirmation.show,
      imgContent: attrModalConfirmation.imgContent,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle"])
  ]))
}
}

})